import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { resolveKlubMediaUrl } from '../../../config/klubApiConfig';

function MagazineMedia({ path, fallbackIcon = 'mdi:image-outline', alt = '', resolveUrl }) {
  const src = (resolveUrl || resolveKlubMediaUrl)(path);
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [path]);

  if (!src || broken) {
    return <Icon icon={fallbackIcon} aria-hidden />;
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setBroken(true)}
    />
  );
}

export default MagazineMedia;
